import React, { useState } from 'react';

const LS_IDX_KEY = "FACT_IDX"
const FACTS = [
  "Les selfies sont responsables de plus de morts que les requins.",
  "Un rafale (100M d'euro btw) ça représente 0,22% du budget annuel français consacré à la défense.",
  "La perception de notre voix est biaisée par le son qui se propage dans notre mâchoire quand on parle.",
  "Une locomotive de TGV coûte 25 millions d'euros.",
  "On ne peut pas utiliser un stylo à bille dans l'espace mais une arme à feu c'est OK.",
  "Le moyen de transport le plus sûr c'est l'ascenseur.",
  "Une rame de TER pèse 137 tonnes à vide.",
  "Un élan court à 56km/h en moyenne.",
  "La fondue à Genève coûte en moyenne 27€/personne.",
  "Les escargots ont des dents",
  "Il est possible d'acheter (sur eBay) une machine à radio pour la somme de 39000£.",
  "Une dent humaine représente environ 38 calories.",
  "Une vitre d'avion mesure environ 30mm d'épaisseur (c'est de l'acrylique).",
  "Y'a 19 5 millions de dislike sur la vidéo la plus dislike de youtube.",
  "Y'a plus de 2000 gauchers qui meurent tous les ans en essayant d'utiliser un objet conçu pour les droitiers.",
  "Le suicide a déjà été condamné à mort.",
  "Il est interdit légalement de mourir à Longyearbyen en Norvège.",
  "1 aveugle naît toutes les 15 heures.",
  "Les vaches ont des meilleurs potes",
  "Le fils de Ben Laden vit en Normandie et il fait de la peinture.",
  "Quatorze ne rime avec aucun mot.",
  "On cligne des yeux environ 28000 fois par jour.",
  "Y'a 881284 personnes qui sont nées en 1971.",
  "Une seconde correspond à 9 192 631 770 oscillations d'atome de Césium 133.",
  "Le nez de la statue de la liberté mesure 1 37m de long.",
  "Les requins clignent des yeux.",
  "En 2161 toutes les planètes vont être alignées un petit instant.",
  "Les spaghettis ont une taille moyenne de 25 cm.",
  "Le sang d'un chien est à 38 5°C.",
  "La phrase la plus longue de la littérature française vient de Sodome et Gomorrhe et fait 856 mots.",
  "Une vache ça sprint à 25km/h.",
  "Les nouveauw tramways mesurent 43m.",
  "Une clef USB pleine pèse moins qu'une clef USB vide.",
  "AWS a survécu à un DDoS de 2.3 To/s en 2020.",
  "Il n'existe aucun mot sans voyelle en français.",
  "La plus grande frontière terrestre de la France est celle qui nous sépare du Brésil  elle fait 730.4 km.",
  "Il y a 330 nations dans le monde mais seulement 192 reconnus par l'ONU.",
  "Le vol le plus long d'une poule a duré 30 secondes.",
  "La pieuvre à 3 cœurs et 9 cerveaux.",
  "Il y a 206 os et 639 muscles dans le corps humain.",
  "La lettre J n'apparaît nulle part dans le tableau périodique des éléments.",
  "Le briquet a été inventé avant les allumettes.",
  "Chez les canards l'appareil reproducteur masculin à une forme de tire-bouchon.",
  "Chaque russe consomme en moyenne 14 litres de vodka par an.",
  "Les français sont les joueurs de pétanques les plus nombreux au monde  226 502 licencié en 2021.",
  "Gorbatchev est mort en 2022.",
  "Il y a 28 000 km de rail en France dont 4 000 inaccessible au public",
  "Les loopings de grands huit ne sont pas ronds, sinon on prendrait environ 6G.",
  "La température d'un four crématoire se situe entre 800 et 1000 degrés celcius. (globalement termostat 30).",
  "Le dimanche en Angleterre, il est autorisé de tirer à l'arbalète sur des Ecossais.",
  "Tous les pandas du monde appartiennent à la chine.",
  "Le téléphone rouge n'était pas un téléphone mais un fax.",
  "51 est divisible par 17.",
  "Il est possible d'aller en Alaska depuis l'Inde par la mer en ligne droite sans croiser la terre.",
  "Un spermatozoïde va à 1.58 km/an. Soit le trajet Jean-Macé - Debourg à pieds.",
  "Les plaques d'immatriculation ont été inventées au parc de la tête d'or.",
  "84% des espèces animales présentent des comportements homosexuels mais seulement 24% forment des couples homosexuels.",
  "La cicindèle champêtre, l'insecte le plus rapide du monde, peut atteindre 100km/h pour une taille de 1.2cm.",
  "L'eau chlorée tue le sperme en quelques secondes. La piscine minicipale est donc théoriquement, dans certains cas, un moyen de contraception.",
  "Il y a 1268 places dans un OUIGO.",
  "Il a été prouvé qu'en moyenne, seule la moitié de tes amis te considérent leur ami.",
  "Techniquement, et d'un point de vue purement calorique,la bombe Little boy permet de nourrir paris intra-muros pendant environ 701 ans et 132 jours",
  "Le potassium étant radioactif, manger 50 000 000 bananes expose à une dose létale de radiations."
]

function App() {
  const [currentFactIdx, setCurrentFactIdx] = useState(Number(localStorage.getItem(LS_IDX_KEY)) || 0)

  const increment = () => {
    const newIdx = (currentFactIdx + 1) % FACTS.length
    setCurrentFactIdx(newIdx)
    localStorage.setItem(LS_IDX_KEY, newIdx)

  }

  return (
    <div className="h-screen w-screen flex flex-col justify-center items-center bg-gray-50">
      <div className="text-xl md:text-3xl lg:text-7xl font-bold text-center px-3 md:px-12 lg:px-20">
        {FACTS[currentFactIdx]}
      </div>
      <div className="mt-8">
        <button className="bg-[#ec4899] font-bold text-white rounded-md py-2 px-3 hover:shadow-md transition duration-200" onClick={increment}>Un autre</button>
      </div>
    </div>
  );
}

export default App;
